import { ref, defineComponent, watch, computed, nextTick } from 'vue';
import { dayjs, ElEmpty, ElMessage } from 'element-plus';
import { useStore } from '@/store';
import styles from './index.module.less';

const NewLoading = defineComponent({
  name: 'NewLoading',
  setup() {
    const store = useStore();
    let timer = 0;;
    let loadingText_index=ref(0);
    watch(() => store.state.loadingText, (loadingText) => {
      if (loadingText) {
        clearInterval(timer)
        loadingText_index.value=0;
        timer = setInterval(() => { 
          loadingText_index.value++;
        }, 1000)
      } else {
        clearInterval(timer)
        loadingText_index.value=0;
      }
    })
    return {
      store,
      loadingText_index
    };
  },
  render() {
    return (
      <div class={styles.container}>
        <div class={styles['content']}>
          <div class={styles['loading']}></div>
          <div class={styles.text}>{this.store.state.loadingText}</div>
          <div class={styles.text}>({this.loadingText_index}s)</div>

        </div>
      </div>
    );
  },
});

export default NewLoading;
